import {
  Beer,
  Check,
  ChevronLeft,
  ChevronRight,
  Coffee,
  Croissant,
  ExternalLink,
  Grape,
  Landmark,
  Loader2,
  MapPin,
  Martini,
  Minus,
  Navigation,
  Plus,
  Scale,
  Search,
  Send,
  Star,
  Trees,
  UtensilsCrossed,
  type LucideIcon,
} from 'lucide-react'
import type { Activity } from '@sorted/types'
import type { Landmark as LandmarkEntry } from '../lib/landmarks.js'

/**
 * Icons - Lucide, not emoji.
 *
 * Emoji render differently on every platform (and are drawn from a font we do
 * not control), so a card can look playful on one phone and broken on another.
 * Lucide is a consistent 1.5px stroke that inherits `currentColor`, which is
 * what lets the same icon sit on a paper card and inside a green button.
 *
 * Only the icons imported here ship - Lucide tree-shakes per icon.
 */

export const ACTIVITY_ICON: Record<Activity, LucideIcon> = {
  coffee: Coffee,
  brunch: Croissant,
  drinks: Martini,
  dinner: UtensilsCrossed,
  walk: Trees,
  beer_garden: Beer,
}

/** Landmark kind → icon, so a search result reads at a glance. */
export const LANDMARK_ICON: Record<LandmarkEntry['kind'], LucideIcon> = {
  station: Navigation,
  district: MapPin,
  town: Landmark,
}

export {
  Check,
  ChevronLeft,
  ChevronRight,
  ExternalLink,
  Grape,
  Loader2,
  MapPin,
  Minus,
  Navigation,
  Plus,
  Scale,
  Search,
  Send,
  Star,
}

/** A spinner that matches the icon stroke rather than a CSS border ring. */
export function Spinner({ size = 18 }: { size?: number }) {
  return <Loader2 size={size} className="spin" aria-hidden />
}
